import type { FollowInvite } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useFollowInvites } from "./useFollowInvites"

export function useFollowInvite(id: FollowInvite["id"]): [FollowInvite | undefined, boolean] {
  const {
    data: followInvites,
    isLoading,
  } = useFollowInvites()

  const followInvite = useMemo(
    () => followInvites?.find(
      (cachedFollowInvite) => (
        cachedFollowInvite.id === id
      ),
    ),
    [
      followInvites,
      id,
    ],
  )

  const hasLoaded = !(isLoading || followInvites === undefined)

  return [
    followInvite,
    hasLoaded,
  ]
}
